import { useMutation } from '@tanstack/react-query';
import { markLessonFinish } from '../queries/lessons';
import { useLessonStore } from '../../modules/Disciplines/stores/lessonStore';
import { getViewedFromResponse } from '../models/contentView';
import { ViewOrigin } from '../models/contentView';

interface IBody {
  course?: string;
  program?: string;
  origin?: ViewOrigin;
  /** Status explícito de visualização (manual: toggle; automático: sempre true). */
  viewed?: boolean;
}

export function useFinishLesson() {
  // Obs.: a atualização do store (done) é feita pelos próprios consumidores
  // (NextVideo e contentModal), de forma otimista, permitindo alternar
  // marcar/desmarcar. Por isso este hook não força mais `done: true` no onSuccess.
  const { isSuccess, isPending, mutate, data } = useMutation({
    mutationKey: ['finish-lesson-from-card'],
    mutationFn: ({ slug, body }:{ slug: string, body: IBody | null }) => markLessonFinish(slug, body),
    retry: false,
    // Toggle: reflete o status retornado (viewStatus.viewed), não presume `true`.
    onSuccess: (response, { slug }) => {
      const viewed = getViewedFromResponse(response);
      const store = useLessonStore.getState();
      const updatedLessons = store.lessons.map((lesson) =>
        lesson.slug === slug ? { ...lesson, done: viewed } : lesson
      );
      store.setLessons(updatedLessons);
    }
  });

  return {
    isLoading: isPending,
    mutate,
    isSuccess,
    data,
  };
}